module.exports = __webpack_public_path__ + "static/media/replayIcon.9dd93486.svg";